import {reachUrls} from "../../layout/menu-items";

export const SEGMENT_QUERY_PARAM = "segment";

export const marketingSegmentUrl = (segmentId: number): string =>
  `${reachUrls.marketingSegments}?${SEGMENT_QUERY_PARAM}=${segmentId}`;
